import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUiDialog} from "./VanillaReaderUiDialog";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiDialogController extends IVanillaReaderUiComponentController, IVanillaReaderUI {};

/**
 * # VanillaReaderUiDialogController
 *
 * ## RESPONSIBILITIES
 * This base controller mixing class handles all event callbacks from the `VanillaReaderUiDialog` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUiDialog
 *
 * */
export class VanillaReaderUiDialogController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        // Static event callbacks that are triggered regardless of what dialog instance are opened and closed.
        VanillaReaderUiDialog.sharedOnDialogOpened(vanillaReaderUiContext._uiEvent_dialogOpened.bind(vanillaReaderUiContext));
        VanillaReaderUiDialog.sharedOnDialogClosed(vanillaReaderUiContext._uiEvent_dialogClosed.bind(vanillaReaderUiContext));
        // This callback is a bit of a workaround to manage the FocusTrap focus management. Ironic right? ;)
        // When the FocusTrap is deactivated we can safely move focus back to the current reading position.
        VanillaReaderUiDialog.sharedOnDialogFocusTrapDeactivated(vanillaReaderUiContext._uiEvent_dialogFocusTrapDeactivated.bind(vanillaReaderUiContext));
    }

    _uiEvent_dialogOpened (dialogInstance: VanillaReaderUiDialog<any>, dialogTitle: string, _silent: boolean = false): void {
        this.setReaderViewAsNotImportantForAccessibility();
        this.activeDialogTitle = dialogTitle;
        this.activeDialog = dialogInstance;

        this.setReaderViewAsNotImportantForAccessibility();

        this.menuBottom.getComponentElement().inert = true;

    };

    _uiEvent_dialogClosed (_dialogInstance: VanillaReaderUiDialog<any>, dialogTitle: string, silent: boolean = false): void {
        this.setReaderViewAsImportantForAccessibility();
        this.activeDialogTitle = undefined;
        this.activeDialog = undefined;
        if (!silent) {
            this.toaster.toast(`Dialog ${dialogTitle} closed`).catch(console.error);
        }

        if (this.sendRefreshIntentAfterDialogClosed) {
            this.refreshReaderView(true);
        }

        this.setReaderViewAsImportantForAccessibility();

        this.menuBottom.getComponentElement().inert = false;
    };

    _uiEvent_dialogFocusTrapDeactivated(returnFocusOnClose: boolean): void {
        if(returnFocusOnClose) {
            this.focusOnReadingPosition();
        }
    };
}
